import axios from "axios";

export default {
    getActivityById(obj) {
        return axios.post("/course/Activity/getActivityById", obj);
    },
    luckDraw(obj) {
        return axios.post("/course/Activity/luckDraw", obj);
    },
    zhuli(obj) {
        return axios.post("/course/Activity/zhuli", obj);
    },
    getMyZhuli(obj) {
        return axios.post("/course/Activity/getMyZhuli", obj);
    },
    getMyLucky(obj) {
        return axios.post("/course/Activity/getMyLucky", obj);
    },
    getPrize(obj) {
        return axios.post("/course/Activity/getPrize", obj);
    }
};